import { PASSWORD_TYPE_LABELS, PASSWORD_TYPES } from "./IntervalEditForm";

const OrderInfoDisplay = ({ order, passwords }) => {
  const getPasswordByType = (type) => {
    if (!passwords || passwords.length === 0) return null;
    return passwords.find((p) => p.type === type);
  };

  const infoItems = [
    { label: "شماره سفارش", value: order?.orderNumber },
    { label: "شناسه سفارش دهنده", value: order?.courierTrackNumber },
    { label: "تاریخ شروع رزرو", value: order?.startDate },
    { label: "ساعت شروع رزرو", value: order?.startTime },
    { label: "تاریخ پایان رزرو", value: order?.endDate },
    { label: "ساعت پایان رزرو", value: order?.endTime },
  ];

  const paymentLabel = (password) => {
    if (!password) return "ندارد";
    return password.needPayment == "1" || password.needPayment === 1
      ? "دارد"
      : "ندارد";
  };

  return (
    <div className="change-interval-readonly">
      <div className="change-interval-readonly-header">
        <span className="change-interval-readonly-badge">اطلاعات</span>
        <div>
          <h4 className="change-interval-readonly-title">اطلاعات سفارش</h4>
          <p className="change-interval-readonly-desc">
            جزئیات فعلی سفارش و وضعیت رمزها
          </p>
        </div>
      </div>

      <div className="change-interval-info-grid">
        {infoItems.map((item) => (
          <div className="change-interval-info-item" key={item.label}>
            <span className="change-interval-info-label">{item.label}</span>
            <span className="change-interval-info-value">
              {item.value || "-"}
            </span>
          </div>
        ))}
      </div>

      <div className="change-interval-password-table-wrap">
        <div className="change-interval-password-table-title">رمزهای سفارش</div>
        <div className="change-interval-password-table">
          <div className="change-interval-password-table-head">
            <div>نوع رمز</div>
            <div>تاریخ انقضا</div>
            <div>ساعت انقضا</div>
            <div>نیاز به پرداخت</div>
          </div>
          {PASSWORD_TYPES.map((type) => {
            const password = getPasswordByType(type);
            const needsPayment = paymentLabel(password);
            return (
              <div className="change-interval-password-table-row" key={type}>
                <div className="change-interval-password-type">
                  {PASSWORD_TYPE_LABELS[type]}
                </div>
                <div>{password?.expireDate || "-"}</div>
                <div className="change-interval-mono">
                  {password?.expireTime || "-"}
                </div>
                <div>
                  <span
                    className={[
                      "change-interval-status-chip",
                      needsPayment === "دارد"
                        ? "change-interval-status-chip--yes"
                        : "change-interval-status-chip--no",
                    ].join(" ")}
                  >
                    {needsPayment}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OrderInfoDisplay;
